import { render, staticRenderFns } from "./ManageIndex.vue?vue&type=template&id=2f7b8718"
import script from "./ManageIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageIndex.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports